// src/pages/CategoryPage.tsx
import React from 'react';
import Layout from '@/components/layout/Layout';
import HeroSection from '@/components/ui/HeroSection';
import CategoryCard from '@/components/ui/CategoryCard';

interface CategoryPageProps {
  title: string;
  description: string;
  heroImage: string;
  subcategories: Array<{
    title: string;
    imageSrc: string;
    url: string;
  }>;
}

const CategoryPage: React.FC<CategoryPageProps> = ({ 
  title, 
  description, 
  heroImage,
  subcategories
}) => {
  return (
    <Layout
      title={`${title} | Lux Decor by Kamen`}
      description={description}
    >
      <HeroSection
        title={title}
        subtitle="Lux Decor by Kamen"
        description={description}
        ctaText="Kontaktirajte nas"
        ctaLink="/kontakt"
        backgroundImage={heroImage}
      />

      <section className="py-16 bg-luxbeige">
        <div className="container mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-semibold mb-2">Naše Podkategorije</h2>
            <p className="text-luxgray max-w-2xl mx-auto">
              Izberite med našimi visokokakovostnimi izdelki
            </p>
            <div className="h-px w-24 bg-luxgold mx-auto mt-4"></div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {subcategories.map((subcategory, index) => (
              <CategoryCard
                key={index}
                title={subcategory.title}
                imageSrc={subcategory.imageSrc}
                url={subcategory.url}
              />
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default CategoryPage;